// Module
var code = "<div class=\"action\" ng-click=\"$ctrl.editUserName()\" name=\"editUserOption\">{{ \"edit\" | localize }}</div>";
// Exports
module.exports = code;